module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex",
    class: _vm.entity.isVerify == 0 ? 'pb-fixed-btn' : ''
  }, [_c('backTitleBar', {
    attrs: {
      "rightText": _vm.rightText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pd-025 bg-fff"
  }, [_c('div', {
    staticClass: "flex supply-top-name bd-bot",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "supply-label radius"
  }, [_vm._v(_vm._s(_vm.equipment_type[_vm.entity.equipmentType]))]), _vm._v(" "), _c('div', {
    staticClass: "flex1 color-333"
  }, [_vm._v(_vm._s(_vm.entity.shopName))]), _vm._v(" "), (!_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "ml-20",
    class: _vm.entity.isVerify == '0' ? 'color-org' : 'color-000'
  }, [_vm._v(_vm._s(_vm.entity.isVerify == '0' ? '待确认' : "已处理"))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pd-250"
  }, [_c('div', {
    staticClass: "flex-between fs-28 color-999"
  }, [_c('div', [_vm._v("补货人：" + _vm._s(_vm.entity.linkName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.entity.createTime))])]), _vm._v(" "), (_vm.entity.equipmentType == 'rfid') ? _c('div', [_c('div', {
    staticClass: "flex-center mt-30 fs-28"
  }, [(!_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "mr-50",
    class: _vm.entity.addTypeCount && _vm.entity.addTypeCount != 0 ? 'color-org font-bold' : 'color-999'
  }, [_vm._v("补货品种：" + _vm._s(_vm.entity.addTypeCount))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.entity.minusTypeCount && _vm.entity.minusTypeCount != 0 ? 'color-main font-bold' : 'color-999'
  }, [_vm._v("取货品种：" + _vm._s(_vm.entity.minusTypeCount))]), _vm._v(" "), (!_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "mr-50",
    class: _vm.entity.addTypeCount && _vm.entity.addTypeCount != 0 ? 'color-org font-bold' : 'color-999',
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("  补货金额：" + _vm._s(_vm.totalPrice()))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-center mt-8 fs-28"
  }, [(!_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "mr-50",
    class: _vm.entity.addNum && _vm.entity.addNum != 0 ? 'color-org font-bold' : 'color-999'
  }, [_vm._v("补货数量：" + _vm._s(_vm.entity.addNum))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.entity.minusNum && _vm.entity.minusNum != 0 ? 'color-main font-bold' : 'color-999'
  }, [_vm._v("取货数量：" + _vm._s(_vm.entity.minusNum))])])]) : _vm._e(), _vm._v(" "), (_vm.entity.equipmentType == 'weigh') ? _c('div', [_c('div', {
    staticClass: "flex-center mt-30 fs-28"
  }, [(!_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "mr-50",
    class: _vm.entity.addTypeCount && _vm.entity.addTypeCount != 0 ? 'color-org font-bold' : 'color-999'
  }, [_vm._v("补货品种：" + _vm._s(_vm.entity.addTypeCount))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.entity.addTypeCount && _vm.entity.addTypeCount != 0 ? 'color-org font-bold' : 'color-999'
  }, [_vm._v(" 补货金额：¥ " + _vm._s(_vm.totalPrice()))]), _vm._v(" "), _c('div', {
    class: _vm.entity.minusTypeCount && _vm.entity.minusTypeCount != 0 ? 'color-main font-bold' : 'color-999',
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("取货品种：" + _vm._s(_vm.entity.minusTypeCount))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "supply-tab-select mt-15"
  }, [(!_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "tab-item org",
    class: _vm.chageType == 0 ? 'color-org active' : 'color-999',
    on: {
      "click": function($event) {
        return _vm.doChangeType(0)
      }
    }
  }, [_vm._v("补货(" + _vm._s(_vm.entity.addTypeCount) + ")")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-item",
    class: _vm.chageType == 1 ? 'color-main active' : 'color-999',
    on: {
      "click": function($event) {
        return _vm.doChangeType(1)
      }
    }
  }, [_vm._v("取货(" + _vm._s(_vm.entity.minusTypeCount) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chageType == 0),
      expression: "chageType == 0"
    }],
    attrs: {
      "id": "addStock"
    }
  }, [(_vm.eqType == 'rfid') ? _c('div', {
    staticClass: "table-title-box"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.eqType == 'rfid') ? _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, [_c('div', _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'supplyRecordDetail',
            query: {
              batchNo: item.batchNo
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      attrs: {
        "src": item.mainPicView,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex1"
    }, [_c('div', {
      staticClass: "fs-26 color-333"
    }, [_vm._v(_vm._s(item.productName) + "/" + _vm._s(item.specName))])]), _vm._v(" "), _c('div', {
      staticClass: "fs-28 w100 text-center ml-10 pt-25",
      class: item.operateType == 'minus' ? 'color-main' : 'color-org'
    }, [_vm._v(_vm._s(item.price) + "元/" + _vm._s(item.specName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-28 w100 text-center ml-10 pt-25",
      class: item.operateType == 'minus' ? 'color-main' : 'color-org'
    }, [(item.operateType == 'minus') ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v("\n                " + _vm._s(item.num) + "\n              ")])])
  }), 0)])], 1) : _c('div', {
    staticClass: "flex1 posi-rel pd-025",
    staticStyle: {
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch",
      "margin-bottom": "40px"
    }
  }, _vm._l((_vm.curZone.zoneWayStockList), function(layer, $layerIndex) {
    return _c('div', {
      key: $layerIndex,
      staticClass: "card mb-10"
    }, [_c('div', {
      staticClass: "layer-name"
    }, [_vm._v(_vm._s(layer.layerName))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._l((layer.zoneWayItemList), function(item, $index) {
      return _c('div', {
        key: $index,
        staticClass: "list-item pd-250",
        on: {
          "click": function($event) {
            _vm.getScrollerPosition();
            _vm.$router.push({
              name: 'supplyRecordDetail',
              query: {
                batchNo: item.batchNo
              }
            })
          }
        }
      }, [_c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        attrs: {
          "src": item.mainPicView,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "flex1"
      }, [_c('div', {
        staticClass: "fs-26 color-333"
      }, [_vm._v(_vm._s(item.productName) + "/" + _vm._s(item.specName))])]), _vm._v(" "), _c('div', {
        staticClass: "fs-28 w100 text-center",
        class: item.operateType == 'minus' ? 'color-main' : 'color-org'
      }, [_c('span', {
        staticStyle: {
          "font-weight": "bold",
          "font-size": "16px"
        }
      }, [_vm._v(_vm._s(item.wayCode))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(item.weight) + "g\n\n            ")]), _vm._v(" "), _c('div', {
        staticClass: "fs-28 w130 text-center ml-10",
        class: item.operateType == 'minus' ? 'color-main' : 'color-org'
      }, [(item.operateType == 'minus') ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (item.isWeightCalc == 1) ? _c('span', {
        staticStyle: {
          "font-weight": "bold",
          "font-size": "16px"
        }
      }, [_vm._v(_vm._s(item.num / 1000) + "kg")]) : _c('span', {
        staticStyle: {
          "font-weight": "bold",
          "font-size": "16px"
        }
      }, [_vm._v(_vm._s(item.num))]), _vm._v(" "), _c('span', {
        staticClass: "fs-28 w130 text-center ml-10 pt-25",
        class: item.operateType == 'minus' ? 'color-main' : 'color-org'
      }, [_c('br'), _vm._v(_vm._s(item.specialPrice) + "元\n                ")])]), _vm._v(" "), _c('div', {
        staticClass: "fs-28 w130 text-center ml-10"
      }, [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.afterNums),
          expression: "item.afterNums"
        }],
        staticClass: "spacer v-txt",
        attrs: {
          "type": "number",
          "disabled": _vm.entity.isVerify == '1' ? true : false,
          "placeholder": "数量"
        },
        domProps: {
          "value": (item.afterNums)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "afterNums", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-weight": "bold",
          "font-size": "16px"
        }
      }, [_vm._v("\n                  " + _vm._s(item.wayTotalWeight) + "g\n                ")])])])
    })], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chageType == 1),
      expression: "chageType == 1"
    }],
    attrs: {
      "id": "minStock"
    }
  }, [(_vm.eqType == 'rfid') ? _c('div', {
    staticClass: "table-title-box"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.eqType == 'rfid') ? _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, [_c('div', _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'supplyRecordDetail',
            query: {
              batchNo: item.batchNo
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      attrs: {
        "src": item.mainPicView,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex1"
    }, [_c('div', {
      staticClass: "fs-26 color-333"
    }, [_vm._v(_vm._s(item.productName) + "/" + _vm._s(item.specName))])]), _vm._v(" "), _c('div', {
      staticClass: "fs-28 w100 text-center ml-10 pt-25",
      class: item.operateType == 'minus' ? 'color-main' : 'color-org'
    }, [_vm._v(_vm._s(item.price) + "元/" + _vm._s(item.specName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-28 w100 text-center ml-10 pt-25",
      class: item.operateType == 'minus' ? 'color-main' : 'color-org'
    }, [(item.operateType == 'minus') ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v("\n                  " + _vm._s(item.num) + "\n                ")])])
  }), 0)])], 1) : _c('div', {
    staticClass: "flex1 posi-rel pd-025",
    staticStyle: {
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch",
      "margin-bottom": "40px"
    }
  }, _vm._l((_vm.curZoneMin.zoneWayStockList), function(layer, $layerIndex) {
    return _c('div', {
      key: $layerIndex,
      staticClass: "card mb-10"
    }, [_c('div', {
      staticClass: "layer-name"
    }, [_vm._v(_vm._s(layer.layerName))]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._l((layer.zoneWayItemList), function(item, $index) {
      return _c('div', {
        key: $index,
        staticClass: "list-item pd-250",
        on: {
          "click": function($event) {
            _vm.getScrollerPosition();
            _vm.$router.push({
              name: 'supplyRecordDetail',
              query: {
                batchNo: item.batchNo
              }
            })
          }
        }
      }, [_c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        attrs: {
          "src": item.mainPicView,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "flex1"
      }, [_c('div', {
        staticClass: "fs-26 color-333"
      }, [_vm._v(_vm._s(item.productName) + "/" + _vm._s(item.specName))])]), _vm._v(" "), _c('div', {
        staticClass: "fs-28 w100 text-center",
        class: item.operateType == 'minus' ? 'color-main' : 'color-org'
      }, [_c('span', {
        staticStyle: {
          "font-weight": "bold",
          "font-size": "16px"
        }
      }, [_vm._v(_vm._s(item.wayCode))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(item.weight) + "g\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "fs-28 w130 text-center ml-10",
        class: item.operateType == 'minus' ? 'color-main' : 'color-org'
      }, [(item.operateType == 'minus') ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (item.isWeightCalc == 1) ? _c('span', {
        staticStyle: {
          "font-weight": "bold",
          "font-size": "16px"
        }
      }, [_vm._v(_vm._s(item.num / 1000) + "kg")]) : _c('span', {
        staticStyle: {
          "font-weight": "bold",
          "font-size": "16px"
        }
      }, [_vm._v(_vm._s(item.num))]), _vm._v(" "), _c('span', {
        staticClass: "fs-28 w130 text-center ml-10 pt-25",
        class: item.operateType == 'minus' ? 'color-main' : 'color-org'
      }, [_c('br'), _vm._v(_vm._s(item.specialPrice) + "元\n                  ")])]), _vm._v(" "), _c('div', {
        staticClass: "fs-28 w130 text-center ml-10"
      }, [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.afterNums),
          expression: "item.afterNums"
        }],
        staticClass: "spacer v-txt",
        attrs: {
          "type": "number",
          "disabled": _vm.entity.isVerify == '1' ? true : false,
          "placeholder": "数量"
        },
        domProps: {
          "value": (item.afterNums)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "afterNums", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-weight": "bold",
          "font-size": "16px"
        }
      }, [_vm._v("\n                        " + _vm._s(item.wayTotalWeight) + "g\n                      ")])])])
    })], 2)
  }), 0), _vm._v(" "), _c('div')]), _vm._v(" "), (_vm.entity.isVerify == 0 && !_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确认补货记录")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-title"
  }, [_c('div', {
    staticClass: "flex1"
  }, [_vm._v("商品")]), _vm._v(" "), _c('div', {
    staticClass: "w100 text-center ml-10"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "w100 text-center ml-10"
  }, [_vm._v("数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-title-box",
    staticStyle: {
      "margin": "0",
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('div', {
    staticClass: "flex1"
  }, [_vm._v("商品")]), _vm._v(" "), _c('div', {
    staticClass: "w130 text-center ml-10",
    staticStyle: {
      "line-height": "1.1"
    }
  }, [_c('span', [_vm._v("货道"), _c('br'), _vm._v("标准重量")])]), _vm._v(" "), _c('div', {
    staticClass: "w130 text-center ml-10",
    staticStyle: {
      "line-height": "1.1"
    }
  }, [_vm._v("识别数量"), _c('br'), _vm._v("商品单价")]), _vm._v(" "), _c('div', {
    staticClass: "w130 text-center ml-10",
    staticStyle: {
      "line-height": "1.1"
    }
  }, [_vm._v("手工数量"), _c('br'), _vm._v("变化重量")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-title"
  }, [_c('div', {
    staticClass: "flex1"
  }, [_vm._v("商品")]), _vm._v(" "), _c('div', {
    staticClass: "w100 text-center ml-10"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "w100 text-center ml-10"
  }, [_vm._v("数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-title-box",
    staticStyle: {
      "margin": "0",
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('div', {
    staticClass: "flex1"
  }, [_vm._v("商品")]), _vm._v(" "), _c('div', {
    staticClass: "w130 text-center ml-10",
    staticStyle: {
      "line-height": "1.1"
    }
  }, [_vm._v("货道"), _c('br'), _vm._v("标准重量")]), _vm._v(" "), _c('div', {
    staticClass: "w130 text-center ml-10",
    staticStyle: {
      "line-height": "1.1"
    }
  }, [_vm._v("识别数量"), _c('br'), _vm._v("商品单价")]), _vm._v(" "), _c('div', {
    staticClass: "w130 text-center ml-10",
    staticStyle: {
      "line-height": "1.1"
    }
  }, [_vm._v("手工数量"), _c('br'), _vm._v("变化重量")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bfeaad7","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/supplyRecord/detail.vue
// module id = fdYb
// module chunks = 51